import { render } from "./AdminsPage.vue?vue&type=template&id=21843c17&scoped=true"
import script from "./AdminsPage.vue?vue&type=script&lang=js"
export * from "./AdminsPage.vue?vue&type=script&lang=js"

import "./AdminsPage.vue?vue&type=style&index=0&id=21843c17&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21843c17"]])

export default __exports__